export default __webpack_public_path__ + "static/media/ic_analytics.6d1070cb.svg";